import React from 'react';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

type Props = {
  open: boolean;
  /** 移動対象の名前 */
  name: string;
  /** 移動先の絶対パス（例: /src、ルート直下は /） */
  targetPath: string;
  /** 移動対象がフォルダか（配下ごと移動する旨を明記するため） */
  isFolder: boolean;
  submitting?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

/**
 * ノードの D&D 移動の確認ダイアログ。
 * 「{name} を {移動先パス} へ移動しますか？」を表示する。フォルダは配下ごと移動する旨を明記する。
 */
const MoveConfirmDialog: React.FC<Props> = ({
  open,
  name,
  targetPath,
  isFolder,
  submitting,
  onClose,
  onConfirm,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{
        paper: { elevation: 0, sx: { borderRadius: 3, border: 1, borderColor: 'divider' } },
      }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Typography variant="subtitle1" fontWeight={600}>
          移動の確認
        </Typography>
      </DialogTitle>
      <DialogContent>
        <Stack spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            「{name}」を{' '}
            <Typography component="span" variant="body2" color="text.primary" fontWeight={600}>
              {targetPath}
            </Typography>{' '}
            へ移動しますか？
          </Typography>
          {isFolder && (
            <Typography variant="body2" color="text.secondary">
              フォルダは配下のファイル・フォルダごと移動します。
            </Typography>
          )}
        </Stack>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} sx={{ borderRadius: 2, textTransform: 'none', fontWeight: 600 }}>
          キャンセル
        </Button>
        <Button
          variant="contained"
          onClick={onConfirm}
          disabled={submitting}
          sx={{
            borderRadius: 2,
            textTransform: 'none',
            fontWeight: 600,
            boxShadow: 'none',
            '&:hover': { boxShadow: 'none' },
          }}
        >
          移動
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MoveConfirmDialog;
